<template>
  <!-- { active: isActive } -->
  <div class="navWrapper dark-menu notranslate" :class="[navClass]">
    <div id="menu" :class="[{ active: isActive }, !subMenu || 'fuck-off']">
      <el-menu
        ref="menu"
        :background-color="backgroundColor"
        :text-color="color"
        :mode="'horizontal'"
        @select="handleSelect"
        :router="false"
        :default-active="activeIndex"
      >
        <el-menu-item id="logo" index="/" @click="goToRoute({ path: '/' })">
          <v-img
            :transition="false"
            alt="Vuetify Logo"
            :style="
              navClass !== 'light-menu'
                ? '-webkit-filter: grayscale(0);filter: grayscale(0)'
                : '-webkit-filter: grayscale(0);filter: grayscale(0);'
            "
            style="margin-left:-20px; "
            contain
            :src="logo"
            transition="scale-transition"
            width="125"
          />
        </el-menu-item>

        <el-menu-item index="/" @click="goToRoute({ path: '/' })">
          {{ $t("inicio") }}
        </el-menu-item>

        <el-submenu
          class="el-menu-item"
          popper-class="notranslate"
          index="/nosotros"
          v-if="!isTablet"
        >
          <template slot="title">
            {{ $t("nosotros.title") }}
          </template>
          <el-menu-item
            :style="'color:' + color + '!important'"
            index="/nosotros"
            @click="goToRoute({ path: '/nosotros' })"
          >
            {{ $t("nosotros.conocenos") }}
          </el-menu-item>
          <el-menu-item
            :style="'color:' + color + '!important'"
            index="/nosotros"
            @click="goToRoute({ path: '/personal' })"
          >
            {{ $t("personal.alt_title") }}
          </el-menu-item>
        </el-submenu>

        <el-menu-item
          v-else
          index="/nosotros"
          :style="'color:' + color + '!important'"
          @click="goToRoute({ path: '/nosotros' }, true, 'nosotros')"
        >
          {{ $t("nosotros.conocenos") }} <i class="el-icon-arrow-right arrow" />
        </el-menu-item>

        <el-submenu
          class="el-menu-item"
          popper-class="notranslate"
          index="/noticias-y-seminarios"
          v-if="!isTablet"
        >
          <template slot="title">
            <div v-html='$t("noticias-y-seminarios.title")'/>
          </template>
          <el-menu-item
            :style="'color:' + color + '!important'"
            index="/noticias-y-seminarios/noticias"
            @click="goToRoute({ path: '/noticias' })"
          >
            {{ $t("noticias") }}
          </el-menu-item>
          <el-menu-item
            :style="'color:' + color + '!important'"
            index="/noticias-y-seminarios/seminarios"
            @click="goToRoute({ path: '/seminarios' })"
          >
            
            {{ $t("seminarios.title") }}
          </el-menu-item>
        </el-submenu>

        <el-menu-item
          v-else
          index="/noticias-y-seminarios"
          :style="'color:' + color + '!important'"
          @click="goToRoute({ path: '/nosotros' }, true, 'noticias_y_seminarios')"
        >
        <div v-html='$t("noticias-y-seminarios.title")'/> <i class="el-icon-arrow-right arrow" />
        </el-menu-item>

        <el-submenu class="el-menu-item" popper-class="notranslate" index="3" v-if="!isTablet">
          <template slot="title">
            <div v-html="$t('investigacion_posgrados.title')" />
          </template>

          <el-submenu class="" popper-class="notranslate" index="3-1" v-if="!isTablet">
            <template slot="title">
              {{ $t("investigacion.title") }}
            </template>

            <el-menu-item
              index="/investigacion/Acuacultura"
              @click="goToRoute({ path: '/investigacion/Acuacultura' })"
            >
              {{ $t("investigacion.acuacultura") }}
            </el-menu-item>
            <el-menu-item
              index="/investigacion/ecologia-marina-integrativa"
              @click="
                goToRoute({
                  path: '/investigacion/ecologia-marina-integrativa'
                })
              "
            >
              {{ $t("investigacion.ecologia") }}
            </el-menu-item>
            <el-menu-item
              index="/investigacion/biogeoquimica-marina-y-cambio-global"
              @click="
                goToRoute({
                  path: '/investigacion/biogeoquimica-marina-y-cambio-global'
                })
              "
            >
              {{ $t("investigacion.biogeoquimica") }}
            </el-menu-item>
            <el-menu-item
              index="/investigacion/ciencias-ambientales-y-del-agua"
              @click="
                goToRoute({
                  path: '/investigacion/ciencias-ambientales-y-del-agua'
                })
              "
            >
              {{ $t("investigacion.ciencias") }}
            </el-menu-item>
            <el-menu-item
              index="/investigacion/oceanografia-fisica"
              @click="goToRoute({ path: '/investigacion/oceanografia-fisica' })"
            >
              {{ $t("investigacion.oceanografia") }}
            </el-menu-item>
          </el-submenu>

          <el-submenu class="" popper-class="notranslate" index="4-1" v-if="!isTablet">
            <template slot="title">
              {{ $t("posgrados.title") }}
            </template>
            <!-- <el-menu-item index="/posgrados" @click="goToRoute({ path: '/posgrados' })">
            Oferta Académica
          </el-menu-item> -->
            <!-- <el-submenu popper-class="notranslate" index="/posgrados">
            <template slot="title">{{ $t("posgrados.oferta") }}</template> -->
            <el-menu-item
              index="/posgrados/doctorado-en-medio-ambiente-y-desarrollo"
              @click="goToRoute({ path: '/posgrados/doctorado-en-medio-ambiente-y-desarrollo' })"
            >
              {{ $t("posgrados.doctorado") }}
            </el-menu-item>
            <el-menu-item
              index="/posgrados/oceanografia-costera"
              @click="goToRoute({ path: '/posgrados/oceanografia-costera' })"
            >
              {{ $t("posgrados.oceanografia") }}
            </el-menu-item>
            <el-menu-item
              index="/posgrados/gestion-ambiental"
              @click="goToRoute({ path: '/posgrados/gestion-ambiental' })"
            >
              {{ $t("posgrados.gestion") }}
            </el-menu-item>

            <!-- </el-submenu> -->
            <el-menu-item index="/posgrados/calendario">
              <a target="_blank" :href="calendarLink">{{ $t("posgrados.calendario") }}</a>
            </el-menu-item>
            <!-- <el-menu-item index="/Oceanografia" @click="goToRoute({ path: '/oceanografia-costera' })">
            Oceanografía Costera
          </el-menu-item> -->
          </el-submenu>
        </el-submenu>

        <el-menu-item
          v-else
          index="/investigacion"
          :style="'color:' + color + '!important'"
          @click="goToRoute({ path: '/nosotros' }, true, 'investigacion')"
        >
          <div v-html="$t('investigacion.title')" />
          <i class="el-icon-arrow-right arrow" />
        </el-menu-item>

        <!-- <el-submenu class="el-menu-item" popper-class="notranslate" index="4" v-if="!isTablet">
          <template slot="title">
            {{ $t("posgrados.title") }}
          </template>
          <el-menu-item
            index="/posgrados/doctorado-en-medio-ambiente-y-desarrollo"
            @click="goToRoute({ path: '/posgrados/doctorado-en-medio-ambiente-y-desarrollo' })"
          >
            {{ $t("posgrados.doctorado") }}
          </el-menu-item>
          <el-menu-item
            index="/posgrados/oceanografia-costera"
            @click="goToRoute({ path: '/posgrados/oceanografia-costera' })"
          >
            {{ $t("posgrados.oceanografia") }}
          </el-menu-item>
          <el-menu-item
            index="/posgrados/gestion-ambiental"
            @click="goToRoute({ path: '/posgrados/gestion-ambiental' })"
          >
            {{ $t("posgrados.gestion") }}
          </el-menu-item>

          <el-menu-item index="/posgrados/calendario">
            <a target="_blank" :href="calendarLink">{{ $t("posgrados.calendario") }}</a>
          </el-menu-item>
        </el-submenu> -->

        <el-menu-item
          v-if="isTablet"
          index="/posgrados"
          :style="'color:' + color + '!important'"
          @click="goToRoute({ path: '/nosotros' }, true, 'posgrados')"
        >
          {{ $t("posgrados.title") }} <i class="el-icon-arrow-right arrow" />
        </el-menu-item>

        <el-menu-item index="/transparencia" @click="goToRoute({ path: '/transparencia' })">
          {{ $t("transparencia") }}
        </el-menu-item>
        <el-menu-item
          index="/incidencia-social"
          @click="goToRoute({ path: '/incidencia-social' })"
          :class="$vuetify.breakpoint.mdAndUp ? 'pt-3' : null"
          v-html="$t('incidencia.title')"
        >
        </el-menu-item>

        <el-submenu
          class="el-menu-item"
          popper-class="notranslate"
          index="/tramites"
          v-if="!isTablet"
        >
          <template slot="title">
            {{ $t("tramites.title") }}
          </template>
          <el-menu-item index="/tramites" @click="goToRoute('https://forms.gle/owmjjDEVeTpJgR1Q7')">
            {{ $t("tramites.oficios") }}
          </el-menu-item>
          <el-menu-item index="/tramites" @click="goToRoute('https://sibecas.uabc.mx/admin')">
            {{ $t("tramites.solicitudes") }}
          </el-menu-item>
          <el-menu-item index="/tramites" @click="goToRoute('http://siii.uabc.mx')">
            {{ $t("tramites.sistema") }}
          </el-menu-item>
          <el-menu-item
            index="/tramites"
            @click="
              goToRoute(
                'http://www.uabc.mx/recursos/Formatos/ManualExpedienteConstanciaTrabajo.pdf'
              )
            "
          >
            {{ $t("tramites.constancia") }}
          </el-menu-item>
          <el-menu-item
            index="/tramites"
            @click="goToRoute('http://sriagral.uabc.mx/Sistema/Sabaticos/')"
          >
            {{ $t("tramites.sabaticos") }}
          </el-menu-item>
        </el-submenu>
        <el-menu-item
          v-else
          index="/tramites"
          :style="'color:' + color + '!important'"
          @click="goToRoute({ path: '/nosotros' }, true, 'tramites')"
        >
          {{ $t("tramites.title") }} <i class="el-icon-arrow-right arrow" />
        </el-menu-item>
      </el-menu>

      <div class="sub-media-menu">
        <ul
          role="menubar"
          class="el-menu--horizontal el-menu"
          style="background-color: rgb(25, 48, 65);"
        >
          <li role="menuitem" tabindex="0" @click="goBack()" class="el-menu-item back-cell">
            <i class="el-icon-arrow-left mb-1" /> {{ $t("regresar") }}
          </li>

          <li
            v-for="option in subMenus[menuIndex]"
            :key="option.text"
            role="menuitem"
            tabindex="0"
            @click="goToRoute(option.path)"
            class="el-menu-item submenu-cell pl-4"
            style="font-size: 16px !important;"
          >
            <i>-</i>
            <div class="pl-2">{{ $t(option.text) }}</div>
          </li>
        </ul>
      </div>
    </div>
    <div id="toggle" @click="toggle()">
      <div class="span" id="top" :class="{ active: isActive }"></div>
      <div class="span" id="middle" :class="{ active: isActive }"></div>
      <div class="span" id="bottom" :class="{ active: isActive }"></div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import config from "../../config";

export default {
  components: {},
  computed: {
    logo: () => require("../../assets/logo_iio.png"),
    calendarLink: function() {
      return this.$info.about.information.calendarLink;
    }
  },
  data() {
    return {
      subMenu: false,
      menuIndex: "",
      activeIndex: "/",
      isActive: false,
      backgroundColor: "white",
      pageAttrs: null,
      isTablet: window.innerWidth <= 960,
      navClass: "",
      backgroundColor: "",
      color: "",
      subMenus: {
        nosotros: [
          { path: { path: "/nosotros" }, text: "nosotros.title" },
          { path: { path: "/personal" }, text: "personal.alt_title" }
        ],
        noticias_y_seminarios: [
          { path: { path: "/noticias" }, text: "noticias" },
          { path: { path: "/seminarios" }, text: "seminarios.title" }
        ],
        investigacion: [
          { path: { path: "/investigacion/Acuacultura" }, text: "investigacion.acuacultura" },
          {
            path: { path: "/investigacion/ecologia-marina-integrativa" },
            text: "investigacion.ecologia"
          },
          {
            path: { path: "/investigacion/biogeoquimica-marina-y-cambio-global" },
            text: "investigacion.biogeoquimica"
          },
          {
            path: { path: "/investigacion/ciencias-ambientales-y-del-agua" },
            text: "investigacion.ciencias"
          },
          {
            path: { path: "/investigacion/oceanografia-fisica" },
            text: "investigacion.oceanografia"
          },
          {
            path: { path: "/investigacion/laboratorio-de-paleoceanografia" },
            text: "investigacion.laboratorio"
          }
        ],
        posgrados: [
          {
            path: { path: "/posgrados/doctorado-en-medio-ambiente-y-desarrollo" },
            text: "posgrados.doctorado"
          },
          { path: { path: "/posgrados/oceanografia-costera" }, text: "posgrados.oceanografia" },
          { path: { path: "/posgrados/gestion-ambiental" }, text: "posgrados.gestion" },
          { path: "calendar", text: "posgrados.calendario" }
        ],
        tramites: [
          { path: "http://ambiente.ens.uabc.mx/oficios-comision", text: "tramites.oficios" },
          { path: "https://sibecas.uabc.mx/admin", text: "tramites.solicitudes" },
          { path: "http://siii.uabc.mx", text: "tramites.sistema" },
          // { path: "http://www.uabc.mx/recursos/", text: "tramites.reembolso" },
          {
            path: "http://www.uabc.mx/recursos/Formatos/ManualExpedienteConstanciaTrabajo.pdf",
            text: "tramites.constancia"
          },
          {
            path: "http://sriagral.uabc.mx/Sistema/Sabaticos/",
            text: "tramites.sabaticos"
          }
        ]
      }
    };
  },
  beforeMount: function() {
    this.activeIndex = this.$route.path;
  },
  mounted: function() {
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.onresize);

    const attrs = config.headerAtributes.find(page => page.name === this.$route.name);
    this.pageAttrs = attrs;
    this.ColorNav();
  },
  unmounted() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("resize", this.onresize);
  },
  watch: {
    "$route.name"(to, from) {
      this.setMenu(false);
      const attrs = config.headerAtributes.find(page => page.name === to);
      this.pageAttrs = attrs;
      this.ColorNav();
    },
    "$route.path"(to, from) {
      this.setMenu(false);
      const value = to.includes("transparencia") ? "/transparencia" : to;
      this.activeIndex = value;
    }
  },
  methods: {
    ColorNav(force) {
      if (force) {
        this.navClass = "light-menu";
        this.backgroundColor = "white";
        this.color = config.colors.midgrey;
      } else {
        if (this.pageAttrs) {
          this.navClass = "dark-menu";
          this.backgroundColor = config.colors.darkblue;
          this.color = "white";
        } else {
          this.navClass = "light-menu";
          this.backgroundColor = "white";
          this.color = config.colors.midgrey;
        }
      }
    },
    goToRoute(route, evt, index) {
      if (evt) {
        this.menuIndex = index;
        this.subMenu = true;
      } else {
        try {
          route.path.length;
          this.$router.push(route);
        } catch (e) {
          // console.warn("vales pa purrra");
          window.open(route === "calendar" ? this.calendarLink : route);
        }
      }

      // this.$router.push(route) : null;
    },
    handleSelect(key, keyPath) {
      const formatedKey = key.replace("/", "");
      if (this.subMenus[formatedKey] !== undefined) this.$refs.menu.activeIndex = this.$route.path;
    },
    onresize: function() {
      this.isTablet = window.innerWidth <= 992;
    },
    toggle: function() {
      this.isActive = !this.isActive;
      if (!this.isActive) this.subMenu = false;
    },
    setMenu(value) {
      this.isActive = value;
      if (!value) this.subMenu = false;
    },
    goBack() {
      this.subMenu = false;
    },
    handleScroll(event) {
      const { pageAttrs } = this;
      if (pageAttrs) {
        if (window.scrollY > config.headerConstants[pageAttrs.tier - 1]) {
          this.ColorNav(true);
        } else this.ColorNav();
      }
    }
  }
};
</script>
